import { User, UserInformation } from '@xver/@types/user';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    LEVEL_1: '/v1/kyc/level-1',
    LEVEL_2: '/v1/kyc/level-2',
};

export function confirmKYCLevel1(
    payload: UserInformation
): Promise<{ message: string; data: User }> {
    return httpClient.post(ENDPOINTS.LEVEL_1, payload);
}

export function confirmKYCLevel2(files: {
    frontCard: File;
    standardPhoto: File;
}): Promise<{ message: string; data: User }> {
    const formData = new FormData();
    formData.append('front-card', files.frontCard);
    formData.append('standard-photo', files.standardPhoto);

    return httpClient.post(ENDPOINTS.LEVEL_2, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
